/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"

import Header from "./Header"
import Footer from "./Footer"
import ScrollToTopButton from "../shared/ScrollToTopButton"

const Layout = ({ children }) => {
  return (
    <>
      <Header />
      <div className="mx-auto max-w-[960px] px-4">
        <main>{children}</main>
      </div>
      <Footer />
      <ScrollToTopButton target="doCafe" />
    </>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
